import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles.css'
import { setupServiceWorkerReload } from './lib/swReload'

// Qordo is installed and demoed as a PWA. Force update checks and reload once
// when a newer service worker takes control so stale cached shells disappear.
try {
  if ('serviceWorker' in navigator) {
    setupServiceWorkerReload(navigator.serviceWorker, window, sessionStorage)
  }
} catch {
  // PWA updates must never break the app.
}

// One traffic beacon per browser session. The /api/track endpoint forwards to
// HQ server-side, so no secret is ever exposed in client code.
try {
  if (!sessionStorage.getItem('qordo_tracked')) {
    sessionStorage.setItem('qordo_tracked', '1')
    const body = JSON.stringify({ referrer: document.referrer || '', url: location.href })

    if (typeof navigator.sendBeacon === 'function') {
      navigator.sendBeacon('/api/track', new Blob([body], { type: 'application/json' }))
    } else if (typeof fetch === 'function') {
      void fetch('/api/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => undefined)
    }
  }
} catch {
  // Tracking must never break the app.
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
